module.exports = __webpack_public_path__ + "static/media/tip_cat_cat.110d24eb.png";